import { create } from "zustand";
import { produce } from "immer";
import axios, { apiBaseUrl } from '../services/http';

export const useConfigStore = create((set) => ({
  config: false,
  fetch: async () => {
    const response = await axios.get(`${apiBaseUrl}/api/config`);
    set({ config: response.data });
  },
}));

export const useSpacesStore = create((set) => ({
  spaces: null,
  fetch: async () => {
    const response = await axios.get(`${apiBaseUrl}/api/spaces`);
    set({ spaces: response.data });
  },
}));

export const useAccountStore = create((set) => ({
  me: null,
  loginOk: (data) => set({ me: data }),
  fetch: async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/me`);
      set({ me: response.data });
    } catch (error) {}
  },
  logout: async () => {
    try {
      await axios.post(`${apiBaseUrl}/api/logout`);
      set({ me: null });
    } catch (error) {}
  },
}));